import { render, staticRenderFns } from "./PlpDeletedLog.vue?vue&type=template&id=1ad225d8"
import script from "./PlpDeletedLog.vue?vue&type=script&lang=js"
export * from "./PlpDeletedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports